import { styled } from "@mui/material";
import { useTranslation } from "react-i18next";

export const MAIN_CONTENT_ID = "main-content";
export const MAIN_CONTENT_HREF = `#${MAIN_CONTENT_ID}`;

const SkipToContentRoot = styled("a")(({ theme }) => ({
  position: "absolute",
  top: "-40px",
  left: "0",
  zIndex: theme.zIndex.appBar + 1,
  color: "inherit",
  textDecoration: "none",
  "&:focus, &:active": {
    top: "8px",
    left: "8px",
    backgroundColor: theme.palette.common.white,
    padding: "8px",
    borderRadius: "4px",
  },
}));

export interface SkipToContentProps {}

/**
 * SkipToContent component provides a link to skip directly to the main content of the page.
 * It is useful for accessibility purposes, allowing users to bypass navigation links and go straight to the main content.
 *
 * Guideline 2.4.1 Bypass Blocks
 *
 * Provide ways to help users navigate, find content, and determine where they are.
 *
 * @see https://webaim.org/techniques/skipnav/
 *
 */
function SkipToContent(props: SkipToContentProps) {
  const { t } = useTranslation();

  return <SkipToContentRoot href="#main-content">{t("global.skip_to_content")}</SkipToContentRoot>;
}

export default SkipToContent;
